import { render, staticRenderFns } from "./hoeveelheid-capacity.vue?vue&type=template&id=51a12ede&scoped=true"
import script from "./hoeveelheid-capacity.vue?vue&type=script&lang=js"
export * from "./hoeveelheid-capacity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a12ede",
  null
  
)

export default component.exports